import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  EditPredefinedMessagePayload,
  PredefinedMessage,
  PredefinedMessageApiResponse,
} from '@/types/predefined-messages';

import { PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY } from '@/hooks/api/use-category-queries';
import {
  mapPredefinedMessage,
  mapPredefinedMessageFormValuesToApiPayload,
  PREDEFINED_MESSAGES_QUERY_KEY,
} from '@/hooks/api/use-predefined-message-queries';
import httpClient from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

export function useEditPredefinedMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      values,
    }: EditPredefinedMessagePayload): Promise<PredefinedMessage> => {
      const payload = mapPredefinedMessageFormValuesToApiPayload(values);
      const { data } = await httpClient.patch<PredefinedMessageApiResponse>(
        API_ROUTES.predefinedMessages.detail(id),
        payload
      );

      return mapPredefinedMessage(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY });
    },
  });
}
